module.exports = __webpack_public_path__ + "static/media/530JamesPBrawleyDrNW_2018-06-12_95.6418a894.jpg";